import React, { useRef } from "react";
import { Segment, Container, Grid, Placeholder, Card, Rail, Header, GridColumn, Search } from "semantic-ui-react";
import SearchCard from "../../components/SearchCard/SearchCard";
import SearchPane from "../../components/SearchPane/SearchPane";
import InfiniteScroll from 'react-infinite-scroller';
import "./SearchPage.css"

const SearchPage = () => {
  const contextRef = useRef(null)
  const data = [
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "new",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "immidiate",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "new",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "false",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
    {
      location: "مشکین شهر٬ اردبیل",
      pricePerNight: "۳۰۰,۰۰۰",
      type: "",
      description: "آپارتمان یک خوابه دنج و لوکس، دسترسی به فاز خدماتی آسان. نزدیک ایستگاه مینی بوس. دریا و هتل دریایی ترنج ده دقیقه پیاده روی.",
      img: 'https://www.trulia.com/pictures/thumbs_6/zillowstatic/fp/456e5c037fe3c386fbc28082f97aee47-full.webp',

    },
  ]




  return <div className=" ">
    <Container fluid className="p-1 m-7-t m-3-b">
      <Grid centered columns={2} stackable>
        {/* <Grid.Column width={4}>
          <Image src={mapimg} />
        </Grid.Column> */}
        <Grid.Column width={16}>
          {/* <Grid.Row>
            <SearchPane />
          </Grid.Row> */}
          <Grid.Row>
            <InfiniteScroll
              pageStart={0}
              // loadMore={loadFunc}
              hasMore={true}
              loader={<Grid className="p-1" columns={4}>{
                [0, 1, 2, 3].map((item, index) => {
                  return <Grid.Column>
                    <Placeholder>
                      <Placeholder.Header style={{ height: 300, width: 150 }}  >
                      </Placeholder.Header>
                      <Placeholder.Paragraph>
                        <Placeholder.Line length='short' />
                        <Placeholder.Line length='medium' />
                        <Placeholder.Line length="full" />
                      </Placeholder.Paragraph>
                    </Placeholder>
                  </Grid.Column>
                })
              }</Grid>}
            >
              <Grid stackable columns={4}  className="rounded-15 m-1">
                <SearchCard data={data} mobile="16" tablet="8" computer="4" />
              </Grid>
            </InfiniteScroll>
          </Grid.Row>
        </Grid.Column>
      </Grid>
    </Container>
  </div>
}
export default SearchPage